// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IrEv","importantInfo":"styles_importantInfo__L_Zri"};